<div class="profile-form-wrap">

  <div class="profile-form-header">
    <div class="profile-form-header__avatar">
      <i class="pi pi-user"></i>
    </div>
    <div class="profile-form-header__text">
      <h3 class="profile-form-header__title">Informations personnelles</h3>
      <span class="profile-form-header__sub">G&eacute;rez vos informations de profil</span>
    </div>
    @if (!isEditing) {
      <p-button
        label="&Eacute;diter"
        icon="pi pi-pencil"
        severity="secondary"
        [outlined]="true"
        styleClass="profile-btn-edit"
        (onClick)="toggleEditing()"/>
    }
  </div>

  <form [formGroup]="formGroup" class="profile-form">
    <div class="profile-form__row">
      <div class="profile-field">
        <label for="firstname" class="profile-field__label">Pr&eacute;nom</label>
        <input pInputText id="firstname" formControlName="firstname" class="profile-field__input" placeholder="Votre pr&eacute;nom" />
      </div>
      <div class="profile-field">
        <label for="lastname" class="profile-field__label">Nom</label>
        <input pInputText id="lastname" formControlName="lastname" class="profile-field__input" placeholder="Votre nom" />
      </div>
    </div>

    <div class="profile-field">
      <label for="username" class="profile-field__label">
        <i class="pi pi-at"></i> Nom d'utilisateur
      </label>
      <input pInputText id="username" formControlName="username" class="profile-field__input" placeholder="Identifiant de connexion" />
    </div>

    <div class="profile-field">
      <label for="email" class="profile-field__label">
        <i class="pi pi-envelope"></i> Adresse e-mail
      </label>
      <input pInputText id="email" formControlName="email" class="profile-field__input" placeholder="adresse@exemple.com" />
    </div>

    <div class="profile-field">
      <label for="phoneNumber" class="profile-field__label">
        <i class="pi pi-phone"></i> T&eacute;l&eacute;phone
      </label>
      <input pInputText id="phoneNumber" formControlName="phoneNumber" class="profile-field__input" placeholder="+221 XX XXX XX XX" />
    </div>
  </form>

  @if (!formGroup.disabled) {
    <div class="profile-form-actions">
      <p-button
        label="Annuler"
        icon="pi pi-times"
        severity="secondary"
        [outlined]="true"
        styleClass="profile-btn-cancel"
        (onClick)="toggleEditing()"/>
      <p-button
        label="Enregistrer"
        icon="pi pi-check"
        [disabled]="!formGroup.valid"
        [loading]="isLoading"
        styleClass="profile-btn-save"
        (onClick)="update()"/>
    </div>
  }
</div>
